import { featureFlags } from '@shared-services/feature-flags';
import CustomizationsState from 'client/widget-components/ecom/stores/CustomizationsState';
import { Customization } from 'client/widget-components/ecom/stores/types';
import { CustomizationType } from 'client/widget-components/ecom/types/EcomSDK';
import { observer } from 'mobx-react';
import React from 'react';
import { ProductCustomizationsStyles } from '../types';
import { CheckboxCustomization } from './CheckboxCustomization';
import { TextFieldCustomization } from './TextFieldCustomization';

interface CustomizationFieldProps {
    customizationsState: CustomizationsState;
    customization: Customization;
    styles?: ProductCustomizationsStyles;
}

const CustomizationField = ({
    customizationsState,
    customization,
    styles,
}: CustomizationFieldProps) => {
    const isCheckbox = customization.type === CustomizationType.CHECKBOX;

    // TODO replace to switch:case once flag is enabled
    if (isCheckbox) {
        const isCheckboxEnabled = featureFlags.getBoolean(
            'runtime.ssr.checkbox.customizations'
        );

        if (!isCheckboxEnabled) {
            return null;
        }

        return (
            <CheckboxCustomization
                {...customization}
                key={customization.id}
                styles={styles}
                value={customizationsState.values[customization.id] as string[]}
                error={customizationsState.errors[customization.id]}
                onChange={customizationsState.updateValue}
                validateField={customizationsState.validate}
            />
        );
    }

    return (
        <TextFieldCustomization
            {...customization}
            key={customization.id}
            styles={styles}
            value={customizationsState.values[customization.id] as string}
            error={customizationsState.errors[customization.id]}
            onChange={customizationsState.updateValue}
            validateField={customizationsState.validate}
        />
    );
};

export default observer(CustomizationField);
